import { literals } from "@/constants/literals";

export const ADVANCED_SEARACH = {
  area: literals.workstation,
  step: literals.step,
  customerOrderNoserv: literals.customerOrderNoServ,
  orderIn: literals.partIn,
  serialIn: literals.serialIn,
  sapWorkOrder: literals.workOrder,
  orderOut: literals.partOut,
  serialOut: literals.serialOut,
  document9r1: literals.document9R1,
  customer: literals.client,
};
export const MORE_OPTIONS = {
  fechaDesde: literals.dateFrom,
  fechaHasta: literals.dateTo,
  description: literals.description,
  visible: literals.visibleClient,
  ownPackaging: literals.ownPackaging,
  correctPackaging: literals.correctPackaging,
  damagedPackaging: literals.damagedPackaging,
  packagingReference: literals.packagingReference,
  ownPackagingOut: literals.ownPackagingOut,
  iberiaPackagingOut: literals.iberiaPackaging,
};
